<template>
    <div class="box-page">
        <div class="page-header with-underline">
            <div class="d-flex align-items-center justify-content-center">
                <span class="page-title">แก้ไขรูปภาพสลิปต่ออายุ</span>
            </div>
        </div>

        <div class="container text-center">
            <div class="row">
                <div class="col-md-12">
                    <div><label>รูปถ่ายสลิปค่าต่ออายุ</label></div>
                    <img :src="member.imgRenewPaymentSlip" class="img-member mt-2" @click="openImg(member.imgRenewPaymentSlip)">
                    <input type="file" ref="fileRenewPaymentSlip" @change="previewFiles($event, 'bankSlip')" :disabled="isUploading" accept="image/x-png,image/jpeg" style="display:none;">
                    <div class="mt-2">
                        <label class="btn btn-small rounded-pill m-0" :class="{'disabled': isUploading}" @click="$refs.fileRenewPaymentSlip.click()">
                            <template v-if="isUploading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </template>
                            <template v-else v-text="getTextToBtnUpload(member.imgRenewPaymentSlip)">อัพโหลดรูป</template>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center">
            <div class="mt-3">
                <button class="btn btn-small" @click="hideEditPaymentSlip">ย้อนกลับ</button>
                <button class="btn btn-small" @click="updatePaymentSlip">บันทึก</button>
            </div>
        </div>
    </div>
</template>

<script>
import ShareFunction from '../../../share-function';
export default {
    data: function () {
        return {
            initSrcImage: '/goobank_assets/common/img/avatar.png',
            member: {
                id: null,
                type: '',
                imgIdCard: '',
                imgBookBank: '',
                imgAvatar: '',
                imgRenewPaymentSlip: '',
                imgCorpCert: '',
                imgDocJur: '',
            },
            isUploading: false,
        };
    },
    computed: {
        fullStoragePath() {
            return `${this.baseUrl}/${this.storagePath}`;
        },
        isPersonal() {
            return this.member.type === 'personal';
        }
    },
    mounted() {
        this.member.imgRenewPaymentSlip = this.baseUrl + this.initSrcImage;
    },
    methods: {
        showPaymentSlipDetail(itemMember) {
            this.member.id = itemMember.id;
            this.setImage('imgRenewPaymentSlip', itemMember.img_renew_payment_slip);
        },
        setImage(imgIns, imgPath) {
            if (imgPath) {
                this.member[imgIns] = `${this.fullStoragePath}${imgPath}`;
            }
        },
        hideEditPaymentSlip(reloadList = false) {
            this.$emit('hideEditPaymentSlip', reloadList);
        },
        updatePaymentSlip() {
            axios.defaults.headers.common["X-CSRF-TOKEN"] = document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content");
            const fileRenewPaymentSlip = this.$refs.fileRenewPaymentSlip;
            var formData = new FormData();
            formData.append('id', this.member.id);

            if (fileRenewPaymentSlip && fileRenewPaymentSlip.files.length > 0) {
                formData.append('renew_payment_slip', fileRenewPaymentSlip.files[0]);
            }

            var config = {
                onUploadProgress: function(progressEvent) {
                    var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                    console.log('percentCompleted', percentCompleted);
                }
            };
            axios.post(
                `${this.baseUrl}/admin/api/upload-member-payment-slip`,
                formData,
                config,
            )
            .then(({data}) => {
                if (data.success) {
                    alertbox('บันทึกสำเร็จ');
                    this.hideEditPaymentSlip(true);
                } else if (data.message) {
                    alertbox(data.message);
                }
            });
        },
        previewFiles(ev, target) {
            var vm = this;
            var files = event.target.files;
            if (files && files[0]) {
                if (files[0].type != 'image/png' && files[0].type != 'image/jpeg') {
                    window.alertbox('only jpg/jpeg file types are allowed', 'warning');
                    vm.resetAvatar(ev);
                    return;
                }
                var fileSize = files[0].size;
                var mbMaxSize = 5 * (1024 * 1024);
                if (fileSize > mbMaxSize) {
                    window.alertbox('Maximum allowed 5MB for uploaded files', 'warning');
                    vm.resetAvatar(ev);
                    return;
                }
                var reader = new FileReader();
                vm.isUploading = true;
                reader.onload = function(e) {
                    if (target == 'idCard') {
                        vm.member.imgIdCard = e.target.result;
                    } else if (target == 'bookBank') {
                        vm.member.imgBookBank = e.target.result;
                    } else if (target == 'avatar') {
                        vm.member.imgAvatar = e.target.result;
                    } else if (target == 'bankSlip') {
                        vm.member.imgRenewPaymentSlip = e.target.result;
                    } else if (target == 'corpCert') {
                        vm.member.imgCorpCert = e.target.result;
                    } else if (target == 'docJur') {
                        vm.member.imgDocJur = e.target.result;
                    }
                    setTimeout(() => {
                        vm.isUploading = false;
                    }, 500);
                }
                reader.readAsDataURL(files[0]);
            }
        },
        openImg(src) {
            ShareFunction.openImg(src);
        },
        getTextToBtnUpload(src) {
            return (src === this.baseUrl + this.initSrcImage ? 'อัพโหลดรูป' : 'เปลี่ยนภาพ');
        },
    },
    created: function() {
    },
    props: {
        baseUrl: '',
        storagePath: '',
    },
}

</script>
<style lang="scss" scoped>
    .img-member {
        min-width: 200px;
        min-height: 200px;
        max-width: 200px;
        max-height: 200px;
    }
    // #region spin
    @-webkit-keyframes spinner-border {
        to {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @-o-keyframes spinner-border {
        to {
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes spinner-border {
        to {
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .spinner-border {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        border: 0.25em solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        -webkit-animation: spinner-border .75s linear infinite;
        -o-animation: spinner-border .75s linear infinite;
        animation: spinner-border .75s linear infinite;
    }

    .spinner-border-sm {
        width: 1rem;
        height: 1rem;
        border-width: 0.2em;
    }
    // #endregion spin
</style>
